<template>
    <div class="my_goods_car">
        <div >
            <el-breadcrumb separator-class="el-icon-arrow-right" class="path_nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >个人中心</el-breadcrumb-item>
                <el-breadcrumb-item >我的客户</el-breadcrumb-item>
            </el-breadcrumb>
            <el-divider></el-divider>
            <div class="body">
                <el-row style="margin-bottom: 20px;">
                    <el-col :span="12">
                        <el-input placeholder="请输入内容" v-model="input2" class="input-with-select" size="small" style="max-width: 400px;">
                            <el-button slot="append" icon="el-icon-search" @click="searchCustom"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                        <el-button type="primary" @click="createCustom" size="mini">新增</el-button>
                        <el-button type="primary" @click="bindCustomAction" size="mini">绑定</el-button>
                    </el-col>

                </el-row>


                <el-table
                        :data="tableData"
                        border
                        fit
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            label="序号"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="vip_custom_name"
                            label="客户名称"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="vip_custom_phone"
                            label="联系电话"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="地区">
                        <template slot-scope="scope">
                            <div>{{scope.row.province_name}}{{scope.row.city_name}}{{scope.row.area_name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="详细地址">
                    </el-table-column>
                    <el-table-column
                            prop="create_date"
                            label="创建时间">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                            prop="addr"-->
<!--                            label="负责人">-->
<!--                    </el-table-column>-->
                    <el-table-column
                            width="100"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="text"
                                    @click="handleInfo(scope.$index, scope.row)">详情
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="text"
                                    @click="handleEdit(scope.$index, scope.row)"
                            >编辑
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
<!--                                        hide-on-single-page-->
                <div style="text-align: right">
                    <el-pagination
                            layout="prev, pager, next"
                            :current-page="currentPage"
                            :page-count="pageCount"

                            @current-change="curentChangeAction"
                    >
                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="showCreateCustom"
                width="70%"
                >
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="客户名称" required>
                    <el-input v-model="form.custom_name"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" required>
                    <el-input v-model="form.custom_phone"></el-input>
                </el-form-item>
                <el-form-item label="地区" required>
                    <el-row>
                        <el-col :span="8">
                            <el-select v-model="value1" placeholder="省"

                                       @focus="remoteMethod"
                                       @change="changeRemoteMethod"
                            >
                                <el-option
                                        v-for="item in options"
                                        :key="item.region_id"
                                        :label="item.region_name"
                                        :value="item.region_id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-select v-model="value2" placeholder="市" :label="value2Key"
                                       @focus="remoteMethod1"
                                       @change="changeREmoteMethod2"
                            >
                                <el-option
                                        v-for="item in options2"
                                        :key="item.region_id"
                                        :label="item.region_name"
                                        :value="item.region_id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-select v-model="value3" placeholder="区" :label="value3Key"
                                       @focus="remoteMethod2">
                                <el-option
                                        v-for="item in options3"
                                        :key="item.region_id"
                                        :label="item.region_name"
                                        :value="item.region_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input type="textarea" v-model="form.address"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="handleCloseShow">取 消</el-button>
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title="绑定客户"
                :visible.sync="showBindCustomDialog"
                width="50%"
        >
            <el-row style="margin-bottom: 20px;">
                <el-col :span="12">
                    <el-input placeholder="请输入客户手机号" v-model="inputBindCustomPhone" class="input-with-select" size="small" style="max-width: 400px;">
                        <el-button slot="append" icon="el-icon-search" @click="searchBindCustom"></el-button>
                    </el-input>
                </el-col>
                <el-col>
                    <div>{{cCustomInfo}}</div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
    <el-button @click="bindCustonCloseShow">取 消</el-button>
    <el-button type="primary" @click="bindCustomDialogAction">绑定</el-button>
  </span>
        </el-dialog>

    </div>

</template>

<script>


export default {
  name: "custom_list",
  data() {
    return {
      title:'新建客户',
      input2: '',
      tableData: [],
      showCreateCustom: false,
        showBindCustomDialog:false,
        inputBindCustomPhone:'',
        cCustomInfo:'无数据',
        cCustom:'',
      form: {
        custom_name: '',
        custom_phone: '',
        province_id: '',
        city_id: '',
        area_id: '',
        address: ''
      },
      loading: false,
      options: [],
      region: 1,
      value1: '',
      value1Key:'',
      value2: '',
      value2Key:'',
      options2: [],
      value3: '',
      value3Key:'',
      options3: [],
      custom_info:{},
      isEdit:false,
      pageCount:0,
      currentPage:1,
    }
  },
  methods: {
      bindCustomAction(){
          this.showBindCustomDialog = true;
      },
      bindCustonCloseShow(){
          this.cCustom = ""
          this.cCustomInfo="无数据"
          this.inputBindCustomPhone = ""
          this.showBindCustomDialog = false;
      },
      bindCustomDialogAction(){
        // 绑定客户
            if (this.cCustom.vip_custom_hash == undefined || this.cCustom.vip_custom_hash == ''){
                this.$message({
                    message: '无法绑定',
                    type: 'warning'
                });
                return;
            }
          this.$http({
              url: 'c_custom_b_custom_bind',
              data: {
                  vip_custom_hash: this.cCustom.vip_custom_hash,
              },
          }).then(res => {
              if (res.code == 1) {
                  console.log(res.data);
                  // this.tableData = res.data;
                  this.cCustomInfo = res.msg;

              }
              console.log(res);
          }).catch((err) => {
              console.log(err)
          });
      },
      searchBindCustom(){
          //搜索客户
          this.$http({
              url: 'c_custom_search',
              data: {
                  mobile: this.inputBindCustomPhone,
              },
          }).then(res => {
              if (res.code == 1) {
                  console.log(res.data);
                  // this.tableData = res.data;
                  if (res.data.length == 0){
                      console.log('无数据')
                      this.cCustomInfo = res.msg
                  }else{
                      this.cCustom = res.data.vip_custom_info;

                      this.cCustomInfo = this.cCustom.vip_custom_name+'-'+this.cCustom.vip_custom_phone
                  }






              }
              console.log(res);
          }).catch((err) => {
              console.log(err)
          });

      },
    searchCustom(){
      this.currentPage = 1
      this.pageCount = 0
      this.getVipCustomList()
    },
    curentChangeAction(e){
      console.log(e)
      this.currentPage = e;
      this.tableData = [];
      this.getVipCustomList()
    },
    handleCloseShow(){
        this.handleClearCustomData()
      this.showCreateCustom = false;
    },
    // clear custom data
    handleClearCustomData(){
      this.form = {}
      this.value1 = ''
      this.value2 = ''
      this.value3 =''
      this.options =[]
      this.options2=[]
      this.options3 = []
    },
    changeREmoteMethod2() {
      this.value3 = ''
      this.options3 = ''
    },
    changeRemoteMethod() {
      this.value2 = ''
      this.options2 = []
      this.value3 = ''
      this.options3 = []
    },
    remoteMethod2() {
      this.$http({
        url: 'select_region',
        data: {
          region_id: this.value2,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.options3 = res.data;

        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    remoteMethod1() {
      this.$http({
        url: 'select_region',
        data: {
          region_id: this.value1,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.options2 = res.data;

        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    remoteMethod() {
      this.$http({
        url: 'select_region',
        data: {
          region_id: this.region,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.options = res.data;

        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    handleClose() {
      console.log(this.form)
      if (this.form.custom_name === ""){
        this.$message({
          message: '请输入客户名称',
          type: 'warning'
        });
        return;
      }else if(this.form.custom_phone==""){
        this.$message({
          message: '请输入联系电话',
          type: 'warning'
        });
        return;
      }else if(this.value1==="" || this.value2===""||this.value3===""){
        this.$message({
          message: '请选择省市区',
          type: 'warning'
        });
        return;
      }
      if (this.isEdit){
        if (this.value1 === this.custom_info.province_name){
          this.value1 = this.custom_info.province_id
        }
        if (this.value2 === this.custom_info.city_name){
          this.value2 = this.custom_info.city_id
        }
        if (this.value3 === this.custom_info.area_name){
          this.value3 = this.custom_info.area_id
        }
        this.editCustomRequest();
      }else{
        this.createCustomRequest()
      }
    },
    //编辑客户
    editCustomRequest(){
      this.$http({
        url: 'vip_custom_edit_submit',
        data: {
          custom_name: this.form.custom_name,
          custom_phone:this.form.custom_phone,
          province_id:this.value1,
          city_id:this.value2,
          area_id:this.value3,
          address:this.form.address,
          vip_custom_hash:this.form.vip_custom_hash
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          this.form = {}
          this.value1 = ''
          this.value2 = ''
          this.value3 =''
          this.options =[]
          this.options2=[]
          this.options3 = []
          this.$message({
            message: '编辑客户成功',
            type: 'success'
          });
          this.getVipCustomList()
        }
        this.showCreateCustom = false;
        this.isEdit = false;
        console.log(res);
      }).catch((err) => {
        console.log(err)
        this.showCreateCustom = false;
        this.isEdit = false;
        this.$message.error('编辑客户失败');
      });
    },
    // 新建客户
    createCustomRequest(){
      this.$http({
        url: 'vip_custom_add',
        data: {
          custom_name: this.form.custom_name,
          custom_phone:this.form.custom_phone,
          province_id:this.value1,
          city_id:this.value2,
          area_id:this.value3,
          address:this.form.address
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          this.form = {}
          this.value1 = ''
          this.value2 = ''
          this.value3 =''
          this.options =[]
          this.options2=[]
          this.options3 = []
          this.$message({
            message: '新建客户成功',
            type: 'success'
          });
          this.getVipCustomList()
        }
        this.showCreateCustom = false;
        console.log(res);
      }).catch((err) => {
        console.log(err)
        this.showCreateCustom = false;
        this.$message.error('新建客户失败');
      });
    },
    //创建地址
    createCustom() {
      this.handleClearCustomData()
      this.showCreateCustom = true;
      this.title = '新建客户'
    },
    handleInfo(index,e) {
    this.isEdit = false
    this.$router.push({name:'custom_detail',params:{hash:e.vip_custom_hash}})
    },
    handleEdit(index, e){
        this.showCreateCustom = true;
        this.title = "编辑";
        this.isEdit = true;
      this.$http({
        url: 'vip_custom_edit_view',
        data: {
          vip_custom_hash: e.vip_custom_hash,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          this.custom_info = res.data.custom_info
          this.value1 = res.data.custom_info.province_name
          this.value2 = res.data.custom_info.city_name
          this.value3 = res.data.custom_info.area_name
          this.form.custom_name = res.data.custom_info.vip_custom_name
          this.form.custom_phone = res.data.custom_info.vip_custom_phone
          this.form.address = res.data.custom_info.address
          this.form.vip_custom_hash = res.data.custom_info.vip_custom_hash
        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    },
    //请求数据
    getVipCustomList() {
      console.log('2222222');
      this.$http({
        url: 'vip_custom_list',
        data: {
          search_custom: this.input2,
          page: this.currentPage,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          this.tableData = res.data;
        }
        this.pageCount = res.all_page

        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    }
  },
  created() {
    this.getVipCustomList();
  }
}
</script>

<style scoped>
    .my_goods_car {
        /*background: #F7F7F5;*/
        box-sizing: border-box;
        padding-top: 46px;
        /*margin-left: 40px;*/
        /*margin-right: 40px;*/
    }
    .path_nav{
        padding:20px 0 0px;
        margin-left: 40px;
        margin-right: 40px;
    }
    .body{
        margin-left: 40px;
        margin-right: 40px;
    }
</style>
